var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 6,
    viewBox: "0 0 20 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91026 2.6773C4.91026 1.33867 3.79473 0.223145 2.4561 0.223145C1.08959 0.223145 0.00195312 1.33867 0.00195312 2.6773C0.00195312 4.01592 1.08959 5.13145 2.4561 5.13145C3.79473 5.13145 4.91026 4.01592 4.91026 2.6773ZM12.44 2.6773C12.44 1.33867 11.3245 0.223145 9.98589 0.223145C8.64726 0.223145 7.53174 1.33867 7.53174 2.6773C7.53174 4.01592 8.64726 5.13145 9.98589 5.13145C11.3245 5.13145 12.44 4.01592 12.44 2.6773ZM19.9977 2.6773C19.9977 1.33867 18.9101 0.223145 17.5436 0.223145C16.2049 0.223145 15.0894 1.33867 15.0894 2.6773C15.0894 4.01592 16.2049 5.13145 17.5436 5.13145C18.9101 5.13145 19.9977 4.01592 19.9977 2.6773Z",
    fill: "#663399"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsIcon);
export default __webpack_public_path__ + "static/media/points-icon.c311e6e118990c41d34c9eeeebb73b4b.svg";
export { ForwardRef as ReactComponent };